import React from 'react';
import { Skeleton, Box } from '@mui/material';

const RetirosSkeleton = () => {
    // Número de filas del skeleton a mostrar
    const skeletonRows = 8;

    return (
        <Box>
            {/* Filas de la tabla */}
            {Array.from({ length: skeletonRows }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        gap: 2,
                        px: 3,
                        py: 2.5,
                        borderBottom: index < skeletonRows - 1 ? '1px solid #f0f0f0' : 'none',
                        alignItems: 'center',
                    }}
                >
                    {/* Columna: Nombre */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="text" width="70%" height={20} />
                    </Box>

                    {/* Columna: Documento */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="text" width="60%" height={20} />
                    </Box>

                    {/* Columna: Total Retirado */}
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Skeleton variant="text" width="50%" height={20} />
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default RetirosSkeleton;
